import React from 'react';
import Navbar from './Navbar';
import Hero from './Hero';
import Footer from './Footer';
import IceCream from '../assets/icecream.webp';
import AromaMilk from '../assets/aromamilk.png';

const AboutPage = () => {
  return (
    <>
      <Navbar />
      <Hero />
      <div className='max-w-screen-xl mx-auto px-6 py-16 bg-gradient-to-r from-purple-100 via-indigo-200 to-purple-300'>
        <p className='text-4xl font-bold text-center text-sky-900 mb-8'>
          ABOUT US
        </p>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-12 items-center'>
          <div className='text-center bg-white p-8 rounded-xl shadow-lg border-2 border-gray-200'>
            <p className='text-xl font-semibold text-gray-800 mb-6'>
              Welcome to <span className='text-green-600 font-extrabold'>HARE KRISHNA TRADERS</span>
            </p>
            <p className='text-lg text-gray-600'>
              Your trusted provider of ice cream wholesales, dairy products, and cylinder supply. We are committed to delivering quality products to meet your needs, whether for personal use or business operations.
            </p>
            <p className='mt-4 text-lg text-gray-600'>
              At HARE KRISHNA TRADERS, we specialize in supplying a wide range of milk-based products, including fresh dairy, premium ice creams, and other essentials. We ensure top-notch quality and freshness, and offer reliable cylinder supply services, catering to both residential and commercial needs.
            </p>
            <p className='mt-4 text-lg text-gray-600'>
              Our focus goes beyond just providing products—we strive to offer seamless service, timely deliveries, and customer satisfaction. We work closely with trusted suppliers and brands to bring you the best in the market while maintaining eco-friendly and sustainable practices in our operations.
            </p>
            <p className='mt-6 font-semibold text-gray-800'>
              Thank you for choosing HARE KRISHNA TRADERS. We look forward to serving you with quality, reliability, and dedication.
            </p>
          </div>
          <div className='flex flex-col space-y-6'>
            <img src={IceCream} className='rounded-xl shadow-md' alt="Ice Cream" />
            <img src={AromaMilk} className='rounded-xl shadow-md' alt="Aroma Milk" />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AboutPage;
